import type {
  Address,
  AddressLink,
} from '@festina/legalentity-general-types/legalentity'

export const newDefaultAddressLink = (): AddressLink => ({
  _type: 'AddressLink',
  address: { _type: 'Address' } satisfies Address,
})
